/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RuoloDto } from '../../models/ruolo-dto';

export interface ApiAuthRuoloByIdGet$Params {
    /**
     * Id del ruolo da caricare
     */
    ruoloId: number;
}

export function apiAuthRuoloByIdGet(
    http: HttpClient,
    rootUrl: string,
    params: ApiAuthRuoloByIdGet$Params,
    context?: HttpContext,
): Observable<StrictHttpResponse<RuoloDto>> {
    const rb = new RequestBuilder(rootUrl, apiAuthRuoloByIdGet.PATH, 'get');
    if (params) {
        rb.query('ruoloId', params.ruoloId, {});
    }

    return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<RuoloDto>;
        }),
    );
}

apiAuthRuoloByIdGet.PATH = '/api/auth/ruolo-by-id';
